import styles from './Blog.module.css'
import Togglable from '../Togglable'
import PropTypes from 'prop-types'

const Blog = ({ blog, removeBlog, user, addLike }) => {
  const handleRemove = (e, id) => {
    e.preventDefault()
    e.stopPropagation()

    if (
      window.confirm(
        'Are you sure you want to delete this blog?'
      )
    ) {
      removeBlog(id)
    }
  }

  const handleVisit = e => {
    e.stopPropagation()
    e.preventDefault()
    window.open(blog.url, '_blank')
  }

  const handleLikeButton = e => {
    e.preventDefault()
    const blogObject = blog
    blogObject.likes = blog.likes += 1
    e.stopPropagation()
    addLike(blogObject)
  }

  return (
    <div className="blog">
      <Togglable
        label={
          <span className="blog__title">{blog.title}</span>
        }
        visibleContent={
          <p className={styles.blog__author}>
            by {blog.author}
          </p>
        }
      >
        <div
          className={`${styles.blog__likes} small darker`}
        >
          <span
            onClick={handleLikeButton}
            className={`${styles.blog__likeButton} material-icons`}
          >
            favorite
          </span>
          <p> x {blog.likes.toString()}</p>
        </div>

        <div className={styles.blog__footer}>
          <p className="small darker">
            Added by @{blog.user?.username}
          </p>
          <div className={styles.blog__buttonGroup}>
            {user.id === blog.user?.id ? (
              <a href="#">
                <button
                  onClick={e => handleRemove(e, blog.id)}
                  className=""
                >
                  delete
                </button>
              </a>
            ) : null}

            <a href="#">
              <button
                onClick={handleVisit}
                className={` ${styles.blog__visitButton} btn-accent-dark`}
              >
                visit
              </button>
            </a>
          </div>
        </div>
      </Togglable>
    </div>
  )
}

Blog.propTypes = {
  blog: PropTypes.shape({
    user: PropTypes.object,
  }).isRequired,
}

export default Blog
